import FieldStoryPoints from "../../../generic/story-points/story-points";
import FieldConfig from "../../../proto/field-config";
import FieldItemModelStoryPointsCalculated_TableCell from "./render/table/table-cell";
import {SortDirection} from "../../../../data-structures/sort"
import ItemModel from "../../../../model2/item/item-model"

export default class FieldItemModelStoryPointsCalculated extends FieldStoryPoints {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Story points"
        this.label      = "Story points"

        this.renderComponents.tableCell     = FieldItemModelStoryPointsCalculated_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem:ItemModel) => {
                    return listItem.calculatedStoryPoints?.total || 0
                }
            ],
            directions  : [sort]
        }
    }
}